import { experiments } from '../experiments';
import { renderModel } from './renderModel';

const isStudioEditor = renderModel.isStudioEditor();

export const shouldShowNewHomePage = () => {
  const isHomepageRedesign = experiments.is('specs.helpwidget.newHomePage', 'true');
  const isHomePageStudioRedesign = experiments.is('specs.helpwidget.newHomePageStudioDesign', 'true');
  return (
    (isHomepageRedesign && !isStudioEditor) ||
    (isStudioEditor && isHomepageRedesign && isHomePageStudioRedesign)
  );
};
